class Accordion extends HTMLElement {
    constructor() {
        super();
        var elements = this.querySelectorAll('.accordion__list-item-heading');

        elements.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const wrapper = event.target.closest('.accordion__list-item');
                const showOne = event.target.closest('.accordion').classList.contains('accordion--show-one-row');
                if (wrapper) {
                    this.toggle(wrapper, showOne);
                }
            });
        });
    }

    toggle(wrapper, showOne) {
        if (wrapper.classList.contains('active')) {
            wrapper.classList.remove('active');
        } else {
            var allItems = this.querySelectorAll('.accordion__list-item.active');
            if (showOne && allItems.length > 0) {
                allItems.forEach((item) => {
                    item.classList.remove('active');
                });
            }

            wrapper.classList.add('active');
        }
    }
}

customElements.define('accordion-component', Accordion);
